import { EBetButtonState, IBetButtonState } from "./interfaces";
import { EButtonModifier } from "@karma-games/angular-devkit/src/lib/modules/button";
import { Dictionary } from "lodash";

export const betButtonStates: Dictionary<IBetButtonState> = {
    [EBetButtonState.NoBet]: {
        stateName: EBetButtonState.NoBet,
        buttonModifier: EButtonModifier.BUTTON_ATTENTION,
        textKey: "PLACE_BET",
        showAmountInText: false,
        accumulatedAmount: undefined,
        roundId: undefined,
        multiplier: undefined,
        actionInProgress: false,
        autoplayRoundCount: undefined,
        firstHalfCashedOut: undefined
    },
    [EBetButtonState.BetNotPrepared]: {
        stateName: EBetButtonState.BetNotPrepared,
        buttonModifier: EButtonModifier.BUTTON_ATTENTION,
        textKey: "PLACE_BET",
        showAmountInText: false,
        accumulatedAmount: undefined,
        roundId: undefined,
        multiplier: undefined,
        actionInProgress: false,
        autoplayRoundCount: undefined,
        firstHalfCashedOut: undefined
    },
    [EBetButtonState.BetPrepared]: {
        stateName: EBetButtonState.BetPrepared,
        buttonModifier: EButtonModifier.BUTTON_NEGATIVE_RED,
        textKey: "CANCEL",
        showAmountInText: false,
        accumulatedAmount: undefined,
        roundId: undefined,
        multiplier: undefined,
        actionInProgress: false,
        autoplayRoundCount: undefined,
        firstHalfCashedOut: undefined
    },
    [EBetButtonState.Betted]: {
        stateName: EBetButtonState.Betted,
        buttonModifier: EButtonModifier.BUTTON_NEGATIVE_RED,
        textKey: "CANCEL",
        showAmountInText: false,
        accumulatedAmount: undefined,
        roundId: undefined,
        multiplier: undefined,
        actionInProgress: false,
        autoplayRoundCount: undefined,
        firstHalfCashedOut: undefined
    },
    [EBetButtonState.RoundPlaying]: {
        stateName: EBetButtonState.RoundPlaying,
        buttonModifier: EButtonModifier.BUTTON_ACTION,
        textKey: "CASH_OUT",
        showAmountInText: true,
        accumulatedAmount: undefined,
        roundId: undefined,
        multiplier: undefined,
        actionInProgress: false,
        autoplayRoundCount: undefined,
        firstHalfCashedOut: undefined
    }
};

export const betPanelStepperDefaultConfig = {
    initialValue: 1,
    step: .1,
    maxValue: 100000,
    minValue: .1
};

export const multiplierPanelStepperDefaultConfig = {
    initialValue: 1.01,
    step: 0.01,
    maxValue: 100000,
    minValue: 1.01
};

export const betPanelDataDefault = {
    predefinedBetOptions: [],
    betStepperConfig: betPanelStepperDefaultConfig,
    multiplierStepperConfig: multiplierPanelStepperDefaultConfig,
    autoplayConfig: undefined
};
